import { StatusReportFilter } from './status-report-filter.model';

export class StatusRequest {
  statusChanges?: { [key: string]: number; } = {};
  filter?: StatusReportFilter = new StatusReportFilter();
  includeUnitDetails?: boolean;
}
